/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CUL_SIMULACIONES_ITEM = {
  id: 'agro_cultivos_simulaciones',
  screenId: 'agr-cul-simulaciones',
  label: 'Simulaciones',
  description: 'Simulá riego y nutrición antes de sembrar, con clima y suelo del lugar.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Probás un escenario hipotético: campo o zona, cultivo, fecha de siembra y rendimiento esperado. El sistema calcula demanda de agua, calendario de riego sugerido y balance de nutrientes.',
      },
      {
        title: 'Paso 1 — Completar parámetros',
        fields: [
          {
            label: 'Campo / Zona',
            description: 'Lugar de la simulación (obligatorio el campo).',
          },
          {
            label: 'Cultivo',
            description: 'Cultivo del catálogo con Kc y nutrición configurados.',
          },
          {
            label: 'Fecha de siembra',
            description: 'Fecha hipotética de siembra.',
          },
          {
            label: 'Escenario',
            description: 'Escenario de extracción de nutrientes (definido en Configuración → Necesidades nutricionales).',
          },
          {
            label: 'Rendimiento esperado (t/ha)',
            description: 'Meta de rinde usada para estimar necesidades nutricionales.',
          },
          {
            label: 'Superficie (ha)',
            description: 'Hectáreas a simular (por defecto 1).',
          },
          {
            label: 'Prof. radicular (cm)',
            description: 'Profundidad de raíz; si la dejás vacía usa la del cultivo.',
          },
          {
            label: 'Eficiencia de riego',
            description: 'Eficiencia del sistema (ej. 0,75).',
          },
        ],
      },
      {
        title: 'Paso 2 — Generar',
        paragraphs: [
          'Tocá «Generar simulación». Verás indicadores, gráficos de Kc, ETc, lluvia, láminas de riego, agotamiento de agua y balance de nutrientes.',
        ],
        bullets: [
          'No crea una siembra real: solo calcula.',
          'Si faltan clima, suelo o datos del cultivo, el sistema avisa con un mensaje.',
        ],
      },
    ],
  },
}
